import { useQuery } from '@tanstack/react-query';

import { useEcomStoreSelector } from '@/data';
import { useSearchService } from '@/opensearch';
import { PRODUCT_FILTER_ATTRIBUTES } from '@/constants';

export const useBrands = ({ initialBrands }: { initialBrands: string[] }) => {
  const { treez_store_name, customer_type } = useEcomStoreSelector([
    'treez_store_name',
    'customer_type',
  ]);
  const queryKey = ['brands', treez_store_name, customer_type];

  const { getFacetItems } = useSearchService();

  const { data, isLoading, error, isError } = useQuery({
    queryKey,
    queryFn: async () => {
      const brands = await getFacetItems({
        facet: PRODUCT_FILTER_ATTRIBUTES._BRAND,
      });

      return brands;
    },
    initialData: initialBrands,
  });

  return {
    error,
    isError,
    isLoading,
    brands: data ?? [],
  };
};
